<template>
  <div>
    <v-dialog
      v-model="onObjectDialog"
      max-width="600px"
      :disabled="forceCloseObjectDialog"
    >
      <template v-slot:activator="{ on }">
        <svg
          v-on="on"
          :width="objectSize"
          :height="objectSize"
          viewBox="0 0 200 200"
          class="pointer"
          @mouseenter="mouseenter($event)"
          @mouseleave="mouseleave()"
          @touchstart="mouseenter($event)"
          @touchend="mouseleave()"
        >
          <use xlink:href="#path" />
          <image :xlink:href="object.image" width="100%" height="100%" clip-path="url(#masking)" v-if="object.image" />
          <circle cx="100" cy="100" r="75" :fill="convertColor" fill-opacity="0.25" stroke="gray" :stroke-width="object.width" />
          <text fill="black" font-family="sans-serif" font-size="30">
              <textPath xlink:href="#path" startOffset="0%" method="stretch">{{ objectName }}</textPath>
          </text>
          <text x="100" y="115" font-size="40" font-family="sans-serif" text-anchor="middle" alignment-baseline="auto" fill="black">{{ objectMark }}</text>
          <circle cx="100" cy="100" r="96" fill="rgb(255,255,0)" :fill-opacity="fillOpacity" :stroke="mouseStroke || stroke" stroke-width="2" />
        </svg>
      </template>
      <v-card>
        <v-btn icon
          absolute
          top
          right
          @click.prevent="closeObjectDialog()"

        >
          <v-icon color="blue-grey lighten-2">mdi-close</v-icon>
        </v-btn>
        <v-card-title>
          <p class="headline">Object</p>
        </v-card-title>
        <v-card-text>
          <p class="text-small">NameとMarkの表示位置変えたい場合は、右上の<v-icon color="primary">mdi-cog</v-icon>をクリックして変更してください。</p>
          <v-text-field label="Name" v-model="object.name" :placeholder="sheet.markIsName ? $t('Workspace.object.showInCircle') : $t('Workspace.object.showAlongCircle')"></v-text-field>
          <v-text-field label="Mark" v-model="object.mark" :placeholder="!sheet.markIsName ? $t('Workspace.object.showInCircle') : $t('Workspace.object.showAlongCircle')"></v-text-field>
          <v-text-field label="Image" v-model="object.image" placeholder="例：https://xxxxx/mychara.png"></v-text-field>
        </v-card-text>
        <v-card-text>
          <div class="mb-4">
            <p>Color</p>
            <v-item-group
              v-model="object.color"
              class="d-flex flex-wrap"
            >
              <v-item
                v-for="(color, i) in master.colors"
                :key="'color' + i"
              >
                <div
                  class="pa-2 border-style"
                  :style="(convertColor == color) ? 'border-color: #1867c0' : ''"
                  @click="object.color = color"
                >
                  <div
                    class="object-style"
                    :style="{
                      backgroundColor: color
                    }"
                  ></div>
                </div>
              </v-item>
            </v-item-group>
          </div>

          <div class="mb-8">
            <p>Size</p>
            <v-btn-toggle
              color="primary"
              v-model="object.size"
            >
              <template
                v-for="(value, key) in master.sizes"
              >
                <v-btn :key="key" v-text="key" :value="key" class="title"></v-btn>
              </template>
            </v-btn-toggle>
          </div>

          <div class="mb-8">
            <p>Width</p>
            <v-btn-toggle
              color="primary"
              v-model="object.width"
            >
              <template
                v-for="value of [1, 3, 5, 7, 9]"
              >
                <v-btn :key="'object-width-' + value" v-text="value" :value="value" class="title"></v-btn>
              </template>
            </v-btn-toggle>
          </div>

          <div class="mt-8">
            <v-textarea
              outlined
              name="input-7-4"
              label="Note"
              v-model="object.note"
            ></v-textarea>
          </div>

        </v-card-text>

        <v-footer
          color="pink lighten-5"
        >
          <v-container
            text-center
          >
            <v-btn
              color="red"
              dark
              depressed
              @click="deleteObject()"
            >
              {{ $t('Workspace.object.deleteButton') }}
            </v-btn>
          </v-container>
        </v-footer>
      </v-card>
    </v-dialog>
    <v-tooltip
      v-model="showTooltip"
      bottom
      :position-x="tooltipPosition.left"
      :position-y="tooltipPosition.top"
    >
      <span style="white-space: pre-wrap; word-wrap:break-word;">{{ object.note }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import master from '@/json/master.json'

export default {
  props: ['object', 'sheet', 'forceCloseObjectDialog'],
  data () {
    return {
      master: master,
      onObjectDialog: false,
      fillOpacity: 0,
      disabled: false,
      mouseStroke: '',
      showTooltip: false,
      tooltipPosition: {}
    }
  },
  computed: {
    convertColor () {
      return this.object.color.slice(0, 7) // IE対応で、アルファ値を削除
    },
    objectName () {
      return this.sheet.markIsName ? this.object.mark : this.object.name
    },
    objectMark () {
      return !this.sheet.markIsName ? this.object.mark : this.object.name
    },
    objectSize () {
      return this.master.sizes[this.object.size].object
    },
    stroke () {
      return 'none'
    }
  },
  methods: {
    closeObjectDialog () {
      this.onObjectDialog = false
    },
    mouseenter (e) {
      // objectの移動時
      this.fillOpacity = 0.5

      // tooltip表示（PCのみ）
      if (e.clientX && e.clientY) {
        if (localStorage.getItem('viewNote')) {
          this.tooltipPosition.left = e.clientX
          this.tooltipPosition.top = e.clientY
          this.showTooltip = !!this.object.note
        }
      }
    },
    mouseleave () {
      // objectの移動時
      this.fillOpacity = 0

      // tooltip非表示
      this.showTooltip = false
    },
    deleteObject () {
      // 自身のobjectそのものを削除
      this.$delete(this.sheet.objects, this.object.id)
      // close
      this.onObjectDialog = false
    }
  },
  created () {
    // プロパティがないため、デフォルトを入れる
    if (!this.object.width) {
      this.object.width = 1
    }
  }
}
</script>

<style lang="scss" scoped>
  .object-style {
    height: 50px;
    width: 50px;
    border-radius: 25px;
    opacity: 0.25;
    border: 1px solid gray;
  }
  .border-style {
    border: 1px solid white;
    border-radius: 6px;
  }
</style>
